import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output, inject } from '@angular/core';
import { Observer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TuiDialogContext, TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusContent } from '@taiga-ui/polymorpheus';
import { TelegramAuthService } from '@src/app/modules/telegram';
import { EnvService } from '@src/app/modules/env';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'div[telegram-check-auth]',
  templateUrl: './check-auth.component.html',
  styleUrls: ['./check-auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckAuthComponent extends BaseResizableComponent {
  public readonly env = inject(EnvService);
  private readonly telegramAuthService = inject(TelegramAuthService);
  private readonly dialogService = inject(TuiDialogService);

  @Input() infoText = '';

  @Input() emitOnSubscribe = true;

  @Output() onLogged = new EventEmitter<void>();

  isLogged: boolean | null = null;

  isActiveTab = true;

  loading = false;

  constructor() {
    super();

    this.telegramAuthService.isLogged$.pipe(takeUntil(this.destroyed$$)).subscribe(isLogged => {
      this.isLogged = isLogged;

      if (this.emitOnSubscribe && isLogged) {
        this.onLogged.emit();
      }

      this.cdr.markForCheck();
    });

    this.telegramAuthService.isActiveTab$.pipe(takeUntil(this.destroyed$$)).subscribe(isActiveTab => {
      this.isActiveTab = isActiveTab;
      this.cdr.markForCheck();
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.telegramAuthService.isLogged()) {
      this.onLogged.emit();
    }

    this.cdr.markForCheck();
  }

  override ngOnDestroy(): void {
    this.telegramAuthService.preventGetTokenFromBot();

    super.ngOnDestroy();
  }

  showLoginToTelegram(content: PolymorpheusContent<TuiDialogContext>) {
    this.telegramAuthService.allowGetTokenFromBot();

    this.dialogService
      .open(content, {
        closeable: false,
        dismissible: false,
      })
      .subscribe();
  }

  onSuccess(observer: Observer<void>): void {
    observer.complete();

    if (this.isLogged) {
      this.onLogged.emit();
    }
  }
}
